import { render, staticRenderFns } from "./AddAddressModal.vue?vue&type=template&id=51e81684&"
import script from "./AddAddressModal.vue?vue&type=script&lang=js&"
export * from "./AddAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports